<div
    class="d-flex w-100 fyi-scorecard-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="false"
        (collapsedChange)="_collapsed = $event"
        variant="colored"
    >
        <cmps-container-header
            class="text-center"
            [headerColour]="headerColour"
            [textColour]="headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content>
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div
                class="no-data w-100 p-2"
                *ngIf="!(_isLoadingData | async) && _fyiMetrics?.length === 0"
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="!(_isLoadingData | async) && _fyiMetrics?.length !== 0"
            >
                <div class="table-responsive sc-widget-table-fyi">
                    <table class="table table-bordered sc-widget-table">
                        <caption></caption>
                        <thead class="font-weight-bold">
                            <tr>
                                <th scope="col">
                                    {{ _i18n._7146_METRIC_NAME | translate }}
                                </th>
                                <th scope="col">
                                    {{ _i18n._725_ACTUAL | translate }}
                                </th>
                                <th scope="col">
                                    {{ _i18n._726_TARGET | translate }}
                                </th>
                                <th scope="col">
                                    {{ _i18n._768___TO_TARGET | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let fyiMetric of _fyiMetrics">
                                <td class="main text-center">
                                    {{ fyiMetric.metricName }}
                                </td>
                                <td>
                                    {{ fyiMetric.actual | number: '1.0-2' }}
                                </td>
                                <td>
                                    {{ fyiMetric.target | number: '1.0-2' }}
                                </td>
                                <td>
                                    {{
                                        (fyiMetric.target
                                            ? fyiMetric.targetPercentage
                                            : null
                                        ) | percent: '1.0-2'
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
